import { ProjectItemsAction } from './Action';

export const CLEAR_PROJECT_ITEMS = 'CLEAR_PROJECT_ITEMS';

export function clearProjectItems(): ProjectItemsAction {
  return {
    type: CLEAR_PROJECT_ITEMS
  };
}
